export default (function replaceTrialText(eventGroup) {
  let halfOfEvents = Math.floor(eventGroup.events.length / 2);
  eventGroup.events.forEach((event, eventIndex, events) => {
    if (eventIndex > halfOfEvents) {
      events[eventIndex].text = `<p class="ql-align-center">TRIAL VERSION</p>`;
      events[eventIndex].xPos = "center";
      events[eventIndex].yPos = "end";
    }
  });
  return eventGroup;
});